import { render } from "./BoqReview.vue?vue&type=template&id=2b763e56"
import script from "@/assets/boq/BoqReview.js?vue&type=script&lang=js"
export * from "@/assets/boq/BoqReview.js?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__